import { gql } from "@/__generated__/gql";

export const USER_ACTIONS = gql(`
  query UserActions(
    $date: Date!
    $orgId: ID!, 
    $userId: ID!
    $first: Int
    ) {
    node(id: $userId) {
      ... on User {
      id
      actions(
        date: $date
        organizationId: $orgId
        first: $first 
        filter: VISIBLE
      ) {
        edges {
          node {
            id
            actionType {
              id
              displayName
              description
              masterId
            }
            actionGroup {
              id
              name
              masterId
            }
            metrics {
              doneCount
              notDoneCount
              skippedCount
            }
          }
        }
      }
    }
  }
}
`);
